import { render, staticRenderFns } from "./AddToCalendar.vue?vue&type=template&id=127d792d&"
import script from "./AddToCalendar.vue?vue&type=script&lang=js&"
export * from "./AddToCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AddToCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports